import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { removeTile } from "@/services/review.service";
import type { RemoveTileRequest } from "@/types/review.types";

export interface UseRemoveTileOptions {
  onSuccess?: (message: string) => void;
  onError?: (error: string) => void;
}

function getErrorMessage(error: Error): string {
  if (isAxiosError<{ message?: string }>(error)) {
    return error.response?.data?.message ?? error.message;
  }
  return error.message;
}

export const useRemoveTile = (options?: UseRemoveTileOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: RemoveTileRequest) => removeTile(request),
    onSuccess: () => {
      // Invalidate relevant queries to refresh data
      queryClient.invalidateQueries({ queryKey: ["reviews"] });
      queryClient.invalidateQueries({ queryKey: ["storedResponse"] });

      options?.onSuccess?.("Tile removed successfully");
    },
    onError: (error: Error) => {
      const errorMessage = getErrorMessage(error);
      options?.onError?.(errorMessage);
    },
  });
};
